module.exports = __webpack_public_path__ + "img/16.8926e06c.png";